export const FB_BUSINESS_VERIFICATION_STATUS_VERIFIED = "Verified";
